export function AboutBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 opacity-40"
      style={{
        background:
          'radial-gradient(ellipse 80% 50% at 50% 0%, var(--glow-purple) 0%, transparent 50%), radial-gradient(ellipse 50% 40% at 15% 75%, var(--glow-orange) 0%, transparent 45%), radial-gradient(ellipse 50% 40% at 85% 65%, var(--glow-blue) 0%, transparent 45%)',
      }}
    />
  );
}
